import * as jose from 'jose';
import { MAIN } from '../configs/main.config';
import { logger } from './logger.service';

export class Auth {
  private static MSALToken: string;

  static saveMSALToken(token: string): void {
    Auth.MSALToken = token;
  }

  static getHubToken(): string {
    return Auth.MSALToken;
  }

  /**
   * This is dynamics token (for proxy, for signalR)
   */
  static saveDynToken(strToken: string): void {
    const token = JSON.stringify(strToken);
    localStorage.setItem(MAIN.lsTokenKey, token);
  }

  static logOut(): void {
    localStorage.removeItem(MAIN.lsTokenKey);
    localStorage.removeItem(MAIN.lsTenantIdKey);
  }

  static getDynJwtToken(): string {
    const strAuthData = localStorage.getItem(MAIN.lsTokenKey);
    const token = JSON.parse(strAuthData);

    return token;
  }
  /**
   * Checking if token is expired so need to pass login again
   * @returns boolean
   */
  static isLogged(): boolean {
    const token = Auth.getDynJwtToken();
    if (!token) {
      return false;
    }
    const jwtString =
      typeof token === 'string'
        ? token
        : typeof (token as any)?.accessToken === 'string'
          ? (token as any).accessToken
          : typeof (token as any)?.idToken === 'string'
            ? (token as any).idToken
            : undefined;

    try {
      const payload = jose.decodeJwt(jwtString);
      const time = payload.exp;
      if (!time) {
        logger.error('JWT has no exp claim');
        return false;
      }
      const expiredTime = time * 1000;
      const now = Date.now();

      return now < expiredTime;
    } catch (e) {
      logger.critical('Failed to decode JWT', e);
      return false;
    }
  }
}
